<template>
  <q-item
    v-bind="{ clickable, disable, dense, active, activeClass, tag, dark, insetLevel, tabindex, manualFocus, focused }"
    class="module-item"
    @click="$emit('click')"
  >
    <q-item-section
      side
      class="relative-position"
      :top="top"
    >
      <profile-image
        :size="dense ? 'sm' : undefined"
        :initials="user.initials || '#'"
        :profile-image="!withoutProfileImage ? user.profile_image : undefined"
        :color="user.color"
        :master="user.created_company"
      />
    </q-item-section>
    <q-item-section>
      <q-item-label>
        <span
          class="text-bold"
          :style="{'color': readableProfileColor(user.color)}"
        >
          {{ user.name }}
        </span>
      </q-item-label>
      <q-item-label
        v-if="user.email && !withoutEmail"
        caption
      >
        {{ user.email }}
      </q-item-label>
      <slot
        v-if="hasContentSlot"
        name="content"
      />
    </q-item-section>
    <q-item-section
      v-if="hasDefaultSlot"
      side
      :top="top"
      @click="onSideClick"
    >
      <slot />
    </q-item-section>
  </q-item>
</template>

<script>
import itemMixin from 'src/helpers/item'

/*
  Partial to display user information on any page
*/
export default {
  mixins: [itemMixin],
  props: {
    user: {
      required: true,
      type: Object
    },
    withoutEmail: {
      type: Boolean,
      default: false
    },
    // Remove the profile image - but keep the initials
    withoutProfileImage: {
      type: Boolean,
      default: false
    },
    top: {
      type: Boolean,
      default: false
    },
    preventSideClick: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasDefaultSlot () {
      return !!this.$slots.default
    },
    hasContentSlot () {
      return !!this.$slots.content
    }
  },
  methods: {
    onSideClick (e) {
      if (this.preventSideClick) {
        e.stopPropagation()
      }
    }
  }
}
</script>
